var $eventsCalendar = $('#events-calendar');

function eventsCalendarShow() {
    selectLookingStateToggle('#events-calendar-toggle');
    $eventsCalendar.slideDown(200, function () {
        $('body').append('<div id="events-calendar-overlay"/>');
        $('#events-calendar-overlay').css({
            'top': $eventsCalendar.position().top + 'px',
            'opacity': '1'
        });
    });
}

function eventsCalendarHide() {
    var $eventsCalendarOverlay = $('#events-calendar-overlay');
    selectLookingStateToggle('#events-calendar-toggle');
    $eventsCalendar.slideUp(200, function () {
        $eventsCalendarOverlay.css('opacity', '0');
        setTimeout(function () {
            $eventsCalendarOverlay.remove();
        }, 200);
    });
}

if ($eventsCalendar.length) {
    $('#events-calendar-toggle').on('click', function () {
        if ($eventsCalendar.is(':hidden')) {
            eventsCalendarShow();
        } else {
            eventsCalendarHide();
        }
        return false;
    });

    $(document)
        .on('click', '#events-calendar-overlay', function () {
            eventsCalendarHide();
            return false;
        })
        .on('keyup', function (e) {
            if ($eventsCalendar.is(':visible') && e.keyCode == 27) {
                eventsCalendarHide();
            }
            return false;
        });
}

// Calendar
var eventsCalendarOptions = {
    showOtherMonths: false,
    onSelect: function (dateText) {
        $('#events-calendar-date').text(dateText);
        var selectedDate = moment(dateText, 'DD.MM.YYYY');
        window.location = $eventsCalendar.data('url') + '?' + $.param({
            'q[event_date_eq]': selectedDate.format('YYYY-MM-DD')
        });
    },
    beforeShowDay: function (date) {
        var momentDate = moment(date);
        var eventsCount = ($eventsCalendar.data('events') || {})[momentDate.format('YYYY-MM-DD')];
        if (eventsCount) {
            return [true, '', '', eventsCount];
        } else {
            return [true, '', ''];
        }
    }
};

if (MOBILE) {
    eventsCalendarOptions.numberOfMonths = 1;
    eventsCalendarOptions.prevText = '<span class="arrow-round-small arrow-round-small--prev"><i class="fa fa-caret-left"></i></span>';
    eventsCalendarOptions.nextText = '<span class="arrow-round-small arrow-round-small--next"><i class="fa fa-caret-right"></i></span>';
}
if (DESKTOP) {
    eventsCalendarOptions.numberOfMonths = 3;
    eventsCalendarOptions.prevText = '<span class="arrow-round-large arrow-round-large--prev"><i class="fa fa-angle-left"></i></span>';
    eventsCalendarOptions.nextText = '<span class="arrow-round-large arrow-round-large--next"><i class="fa fa-angle-right"></i></span>';
}

$('#events-calendar-placement').datepicker(eventsCalendarOptions);